export const tourVersionHandler = (
    userId: string, 
    isOpen: boolean, 
    setFunction: Function, 
    version: string
): void => {
    const pastVersions: any = JSON.parse(localStorage.getItem("versions") || "{}");
    
    if(isOpen === false){
        if(pastVersions[userId] === undefined){
            setTimeout(() => {
                setFunction(true);
            }, 500);
            
            const addNewVersion = {
                ...pastVersions,
                [userId]: [
                version
                ]
            }
            
            localStorage.setItem("versions", JSON.stringify(addNewVersion));
        } else {
            if(!pastVersions[userId].includes(version)){
                setTimeout(() => {
                    setFunction(true);
                }, 500);
                
                const addNewVersion = {
                    ...pastVersions,
                    [userId]: [
                        ...pastVersions[userId],
                        version
                    ]
                }
                
                localStorage.setItem("versions", JSON.stringify(addNewVersion));
            }
        }
    }
}